import axios from 'axios';

const API_HOST = process.env.REACT_APP_API_BASE_PATH;

export const getReportSummaryData = params =>
  axios.get(`${API_HOST}/reports/summary`, {
    params,
    withCredentials: true
  });

export const getGeneralReportSummaryData = params =>
  axios.get(`${API_HOST}/admin/summary-report/general`, {
    params,
    withCredentials: true
  });

export const getFilteredSummaryData = params =>
  axios.get(`${API_HOST}/admin/summary-report/filter-by-time`, {
    params,
    withCredentials: true
  });

export const getReportGochiAmountsData = params =>
  axios.get(`${API_HOST}/reports/gochis/amount`, {
    params,
    withCredentials: true
  });

export const getReportGochiUserCountsData = params =>
  axios.get(`${API_HOST}/reports/gochis/users/count`, {
    params,
    withCredentials: true
  });

export const getReportGochiCountsData = params =>
  axios.get(`${API_HOST}/reports/gochis/count`, {
    params,
    withCredentials: true
  });

export const getReportShopGochiAMountsData = params =>
  axios.get(`${API_HOST}/reports/shops/gochis/amount`, {
    params,
    withCredentials: true
  });

export const getReportShopGochiTableData = params =>
  axios.get(`${API_HOST}/admin/summary-report/table-detail`, {
    params,
    withCredentials: true
  });

export const getReportShopGroupTotalAmountData = params =>
  axios.get(`${API_HOST}/groups/summary-report/amount-shops/total`, {
    params,
    withCredentials: true
  });

export const getReportShopGroupByDayData = params =>
  axios.get(`${API_HOST}/groups/summary-report/amount-shops/by-days`, {
    params,
    withCredentials: true
  });

export const getReportShopGroupPlatformData = params =>
  axios.get(`${API_HOST}/groups/summary-report/amount-shops/by-platform`, {
    params,
    withCredentials: true
  });

export const getReportShopGroupUserTypeData = params =>
  axios.get(
    `${API_HOST}/groups/summary-report/amount-shops/by-gochi-user-type`,
    {
      params,
      withCredentials: true
    }
  );

export const getReportShopGroupByDayDownloadData = params =>
  axios.get(`${API_HOST}/groups/summary-report/amount-shops/by-days/download`, {
    params,
    withCredentials: true
  });

export const PostStatisticalReportDownloadData = params =>
  axios.post(`${API_HOST}/reports/summary/amount/download`, params, {
    withCredentials: true
  });

export const getReportShopGroupCampaignTotalAmountData = params =>
  axios.get(`${API_HOST}/groups/summary-report/amount-shops/total/campaign`, {
    params,
    withCredentials: true
  });

export const getReportShopGroupCampaignByDayData = params =>
  axios.get(`${API_HOST}/groups/summary-report/amount-shops/by-days/campaign`, {
    params,
    withCredentials: true
  });

export const getReportShopGroupGochiKidTotalAmountData = params =>
  axios.get(`${API_HOST}/groups/summary-report/amount-shops/total/gochi-kid`, {
    params,
    withCredentials: true
  });

export const getReportShopGroupGochiKidByDayData = params =>
  axios.get(
    `${API_HOST}/groups/summary-report/amount-shops/by-days/gochi-kid`,
    {
      params,
      withCredentials: true
    }
  );
